import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import VueYouTubeEmbed from 'vue-youtube-embed'
import VModal from 'vue-js-modal'
import VueLazyLoad from 'vue-lazyload'
import VueAnalytics from 'vue-analytics'
// import jQuery from '../public/scripts/jquery.js'
// import plugin from '../public/scripts/plugins.js'
// import custom from '../public/scripts/custom.js'
// let jQuery=require('../public/scripts/jquery.js');
// global.jQuery=jQuery;
// global.plugin=plugin;
// global.custom=custom;
// import Perks from './Perks.vue'
Vue.use(VueRouter)
Vue.use(VueYouTubeEmbed)
Vue.use(VModal)
Vue.use(VueLazyLoad)
import Perks from './pages/Perks.vue'
import Home from './pages/Home.vue'
import Explore_the_world from './pages/Explore_the_world.vue'
import Menu from './pages/Menu.vue'
//import Follow_us from './pages/introduction/Follow_us.vue'
import Bali from './pages/explore/Bali.vue'
import Insurance from './pages/insurance/Insurance.vue'
import Eye from './pages/eye/Eye.vue'
import Eye_pdf from './pages/eye/Eye_pdf.vue'
import Talent from './pages/talent/Talent.vue'
import Question_set_a from './pages/talent/Question_A.vue'
import Question_set_b from './pages/talent/Question_B.vue'
import Question_set_c from './pages/talent/Question_C.vue'
import Question_set_d from './pages/talent/Question_D.vue'
import Question_set_e from './pages/talent/Question_E.vue'
import Question_set_f from './pages/talent/Question_F.vue'
import Question_set_g from './pages/talent/Question_G.vue'
import Result from './pages/talent/Result.vue'
import Awards from './pages/awards/Awards.vue'
import Roadmap from './pages/roadmap/Roadmap.vue'
import Agent_journey from './pages/roadmap/Agent_journey.vue'
import Agent_journey_normal from './pages/roadmap/Agent_journey_normal.vue'
import Anchoring_program from './pages/roadmap/Anchoring_program.vue'
import Eye_agent_journey from './pages/roadmap/Eye_agent_journey.vue'
import Group_journey from './pages/roadmap/Group_journey.vue'
import Leader_journey from './pages/roadmap/Leader_journey.vue'
import Login from './pages/Login.vue'
// import '../public/scripts/jquery.js'
// import '../public/scripts/plugins.js'
// import '../public/scripts/custom.js'
// import Preloader from './components/Preloader.vue'

import About_generali from './pages/about/About_generali.vue'
import Our_history from './pages/about/Our_history.vue'
import Our_culture from './pages/about/Our_culture.vue'
import Our_priority from './pages/about/Our_priority.vue'

import Life_insurance_opportunity from './pages/insurance/Life_insurance_opportunity.vue'

import Boss from './pages/Boss.vue'

import Career from './pages/career/Career.vue'
import Career_disturb from './pages/career/Disturb.vue'
import Career_solution from './pages/career/Solution.vue'
import Career_result from './pages/career/Result.vue'

Vue.config.productionTip = false

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    { path: '/', component: Login, meta: { requiresAuth: false, header: false, footer:false } },
    { path: '/home', component: Home, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/perks', component: Perks, meta: { requiresAuth: true, header: true, footer:true } },
  
    { path: '/explore-the-world', component: Explore_the_world, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/menu', component: Menu, meta: { requiresAuth: true, header: true, footer:true } },

    //{ path: '/follow-us', component: Follow_us },
    { path: '/bali', component: Bali, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/insurance', component: Insurance, meta: { requiresAuth: true, header: true, footer:true }},
    { path: '/elevale-young-entreprenuers', component: Eye, meta: { requiresAuth: true, header: true, footer:true }},
    { path: '/eye-download', component: Eye_pdf, meta: { requiresAuth: true, header: true, footer:true }},
    { path: '/talent-profiling-guide', component: Talent, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/question-set-a', component: Question_set_a, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/question-set-b', component: Question_set_b, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/question-set-c', component: Question_set_c, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/question-set-d', component: Question_set_d, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/question-set-e', component: Question_set_e, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/question-set-f', component: Question_set_f, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/question-set-g', component: Question_set_g, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/talent-result', component: Result, meta: { requiresAuth: true, header: true, footer:true }},
    { path: '/awards', component: Awards, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/success-roadmap', component: Roadmap, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/agent-journey', component: Agent_journey, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/agent-journey-normal', component: Agent_journey_normal, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/agent-journey-boss', component: Eye_agent_journey, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/anchoring-program', component: Anchoring_program, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/existing-leader-journey', component: Leader_journey, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/newly-promoted-leader', component: Group_journey, meta: { requiresAuth: true, header: true, footer:true } },

    { path: '/about-generali', component: About_generali, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/our-history', component: Our_history, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/our-culture', component: Our_culture, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/our-priority', component: Our_priority, meta: { requiresAuth: true, header: true, footer:true } },

    { path: '/life-insurance-opportunity', component: Life_insurance_opportunity, meta: { requiresAuth: true, header: true, footer:true } },

    // M7 - BOSS
    { path: '/bussiness-opportunity-support-scheme', component: Boss, meta: { requiresAuth: true, header: true, footer:true }},

    // M9 - Career
    { path: '/career-lifestyle-survey', component: Career, meta: { requiresAuth: true, header: true, footer:true }},
    { path: '/career-disturb', component: Career_disturb, meta: { requiresAuth: true, header: true, footer:true }},
    { path: '/career-solution', component: Career_solution, meta: { requiresAuth: true, header: true, footer:true }},
    { path: '/career-result', component: Career_result, meta: { requiresAuth: true, header: true, footer:true }},

    // OLD LINK

    // M1 - About generali
    { path: '/get-to-know-us', component: About_generali, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/our-business', component: About_generali, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/our-ambition', component: About_generali, meta: { requiresAuth: true, header: true, footer:true } },
    { path: '/axa-in-malaysia', component: About_generali, meta: { requiresAuth: true, header: true, footer:true } },

    // M2 - Life Insurance Opportunity
    { path: '/why-insurance', component: Life_insurance_opportunity, meta: { requiresAuth: true, header: true, footer:true } },
  ],
  linkActiveClass: "active-nav",
});

router.beforeEach((to, from, next) => {
  if(to.fullPath!=="/" && to.meta.requiresAuth){
    if(localStorage.getItem('isAuth') !== '1'){
      next({path: '/'})
    }
    else{
      next()
    }
  }
  else{
    next()
  }
})
Vue.use(VueAnalytics, {
  id: 'UA-176752614-1',
  router
})


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
